export const usePlayerStore = defineStore('player-store', {

  persist: true,

  state: () => {
    return {
      snareVolume: 100,
      metronomeVolume: 80,
      barPlaying: 0,
      handsAreSwitched: false,
      currentStage: 0,
      playAnimation: false,
      isPlaying: null,
      loopTotal: 0,
      loopPlaying: 0,
      loopShow: false
    }
  },

  actions: {

    playing(id) {
      this.isPlaying = id
    },

    barIncrement() {
      this.barPlaying = this.barPlaying + 1
    },

    barReset() {
      this.barPlaying = 0
    },

    stage(number) {
      this.currentStage = number
    },

    switch() {
      this.handsAreSwitched = !this.handsAreSwitched
    },

    resetHands() {
      this.handsAreSwitched = false
    }

  },

  getters: {
    getBarPlaying: (state) => state.barPlaying
  },
})


if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePlayerStore, import.meta.hot))
}